import { Upload } from 'lucide-react'
import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { UploadDocumentDialog } from './UploadDocumentDialog'

/** The Upload CTA and its dialog, for any surface listing an org's documents. */
export function UploadDocumentButton({ orgId, disabled = false }: { orgId: string; disabled?: boolean }) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <Button size="sm" onClick={() => setIsOpen(true)} disabled={disabled}>
        <Upload className="size-4" />
        Upload
      </Button>
      {isOpen && <UploadDocumentDialog orgId={orgId} onClose={() => setIsOpen(false)} />}
    </>
  )
}
